import { headerBreakPoint } from '../constants/breakPoints'
import {
  getDeAdPageHeaderEntriesLogin,
  getDeBookADemoButton,
  getDeEntriesLogin,
  getDeEntriesNavigation,
  getDeSearchHeaderEntriesLogin,
  getDeTryItFreeButton,
  getEnAdPageHeaderEntriesLogin,
  getEnBookADemoButton,
  getEnEntriesLogin,
  getEnEntriesNavigation,
  getEnLearnHeaderEntriesLogin,
  getEnSearchHeaderEntriesLogin,
  getEnTryItFreeButton,
  getFrAdPageHeaderEntriesLogin,
  getFrBookADemoButton,
  getFrEntriesLogin,
  getFrEntriesNavigation,
  getFrSearchHeaderEntriesLogin,
  getFrTryItFreeButton,
} from '../constants/header'
import { Language } from '../hooks/useLanguage'
import { AcceptedLanguages, i18next } from '../i18n'
import { ButtonEntry, Entry, Group } from '../interfaces/header'

export const translate = (resource?: string | { en: string; de?: string; fr?: string }): string => {
  if (typeof resource === 'string') {
    return resource
  } else if (!resource) {
    return ''
  } else {
    try {
      return resource[i18next.language as AcceptedLanguages] || resource.en
    } catch {
      return resource.en
    }
  }
}

export const groupsFactory = (
  language: Language,
  entriesLogin: (language: Language) => Entry[] = getEntriesLogin,
  entriesNavigation: (language: Language) => Entry[] = getEntriesNavigation,
  customBreakPoint?: number
): Group[] => [
  {
    alias: 'navigation',
    breakPoint: customBreakPoint || headerBreakPoint,
    entries: entriesNavigation(language),
  },
  {
    alias: 'login',
    breakPoint: customBreakPoint || headerBreakPoint,
    entries: entriesLogin(language),
  },
]

const getEntriesNavigation = (language: Language): Entry[] => {
  switch (language) {
    case 'en':
      return getEnEntriesNavigation()
    case 'fr':
      return getFrEntriesNavigation()
    case 'de':
      return getDeEntriesNavigation()
  }
}

const getEntriesLogin = (language: Language): Entry[] => {
  switch (language) {
    case 'en':
      return getEnEntriesLogin()
    case 'fr':
      return getFrEntriesLogin()
    case 'de':
      return getDeEntriesLogin()
  }
}

export const getBookADemoButton = (language: Language): ButtonEntry => {
  switch (language) {
    case 'en':
      return getEnBookADemoButton()
    case 'fr':
      return getFrBookADemoButton()
    case 'de':
      return getDeBookADemoButton()
  }
}

export const getTryItFreeButton = (language: Language): ButtonEntry => {
  switch (language) {
    case 'en':
      return getEnTryItFreeButton()
    case 'fr':
      return getFrTryItFreeButton()
    case 'de':
      return getDeTryItFreeButton()
  }
}

export const getLearnHeaderEntriesLogin = (language: Language): Entry[] => {
  switch (language) {
    case 'en':
      return getEnLearnHeaderEntriesLogin()
    case 'fr':
      return getEnLearnHeaderEntriesLogin()
    case 'de':
      return getEnLearnHeaderEntriesLogin()
  }
}

export const getAdPageHeaderEntriesLogin = (language: Language): Entry[] => {
  switch (language) {
    case 'en':
      return getEnAdPageHeaderEntriesLogin()
    case 'fr':
      return getFrAdPageHeaderEntriesLogin()
    case 'de':
      return getDeAdPageHeaderEntriesLogin()
  }
}

export const getSearchHeaderEntriesLogin = (language: Language): Entry[] => {
  switch (language) {
    case 'en':
      return getEnSearchHeaderEntriesLogin()
    case 'fr':
      return getFrSearchHeaderEntriesLogin()
    case 'de':
      return getDeSearchHeaderEntriesLogin()
  }
}
